const body  = document.body;

// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


// Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})




// =======================================================
// Animation au chargement
// =======================================================
// window.addEventListener("DOMContentLoaded", (event) => {
//     console.log("DOM fully loaded and parsed");
// });

window.addEventListener("load", (event) => {
    if(window.innerWidth > 1040) {
        // console.log("page is fully loaded");
        setTimeout(function() {
            body.classList.add('is-loaded');
        }, 100);
    }
});

// window.addEventListener("beforeunload", (event) => {
//     if(window.innerWidth > 1040) {
//         // console.log("beforeunload");
//         setTimeout(function() {
//             body.classList.remove('is-loaded');
//         }, 50);
//     }
// });

// window.addEventListener("unload", (event) => {
//     console.log("unload");

// });


// window.addEventListener("load", (event) => {
//     console.log("page is fully loaded");
//     setTimeout(function() {
//         body.classList.add('is-show');

//         masks.forEach(mask => {
//             mask.classList.add('is-show');
//         });
        
//     }, 500);
// });